import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {
    get_hostel_room,
  add_hostel_room,
  update_hostel_room,
  delete_hostel_room,
  get_hostel_room_list,
} from '../Service/ApiServices.js';
import { toast } from 'react-toastify';

const initialState = {
    hostelroom: [],
    hostelroomlist:[],
  school_id:"",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    name: "",
    description:"",
    room_type : "",
    number_of_beds : "",
    cost_per_bed : "",
  },
};

// Async Thunks for API Calls
export const fetchhostelroomlist = createAsyncThunk(
    'hostelroom/fetchhostelroomlist',
    async ({school_id,token, signal }, { rejectWithValue }) => {
      try {
        const response = await get_hostel_room_list(school_id,token, signal);
        if (response.status) {
          return response.response;
        } else {
          return rejectWithValue(response.response.message);
        }
      } catch (error) {
        return rejectWithValue(error.message);
      }
    }
  );
  

// Async Thunks for API Calls
export const fetchhostelroom = createAsyncThunk(
  "hostelroom/fetchhostelroom",
  async ({ page, page_size,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await get_hostel_room(page, page_size,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createhostelroom = createAsyncThunk(
  "hostelroom/createhostelroom",
  async ({ data,school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_hostel_room(data,school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatehostelroom = createAsyncThunk(
  "hostelroom/updatehostelroom",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_hostel_room(data, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletehostelroom = createAsyncThunk(
  "hostelroom/deletehostelroom",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_hostel_room({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// hostel_room Slice
const hostelroomSlice = createSlice({
  name: 'hostelrooms',
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, name,description,room_type ,
        number_of_beds ,
        cost_per_bed  } = action.payload;
      state.formData = { id, name,description,room_type ,
        number_of_beds ,
        cost_per_bed  };
    },
    resetFormData(state) {
      state.formData = {
        name: "",
        description:"",
        room_type : "",
    number_of_beds : "",
    cost_per_bed : "",
      };
    },
    setHostelRoom(state, action) {
      state.hostelroom = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
    .addCase(fetchhostelroomlist.fulfilled, (state, action) => {
        state.hostelroomlist = action.payload.data;
      })
       // Fetch hostel_room
       .addCase(fetchhostelroom.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchhostelroom.fulfilled, (state, action) => {
        state.loading = false;
        state.hostelroom = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchhostelroom.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add hostel_room
      .addCase(createhostelroom.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createhostelroom.fulfilled, (state, action) => {
        state.addLoading = false;
        state.hostelroom = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createhostelroom.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update hostel_room
      .addCase(updatehostelroom.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatehostelroom.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatehostelroom.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete hostel_room
      .addCase(deletehostelroom.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletehostelroom.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletehostelroom.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {   setHostelRoom,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize } = hostelroomSlice.actions;
export default hostelroomSlice.reducer;
